import styled from 'styled-components';

export default {
  Overlay: styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 20;
  `,

  Container: styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    max-height: 80%;
    overflow: auto;
    transform: translateY(-50%) translateX(-50%);
    padding: 24px;
    background: #fff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    z-index: 20;
  `,

  CloseButton: styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    padding: 0;
    margin: 0;
    background: transparent;
    outline: none;
    border: 0;
    opacity: 0.24;

    &:hover,
    &:focus {
      opacity: 1;
    }
  `,

  Title: styled.div`
    margin-right: 16px;
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 26px;
  `,

  Help: styled.div`
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.64);
  `,

  List: styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
  `,
};
